export default {"src":"/_next/static/media/remove-icon.4388bf82.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};